import { createFileRoute } from "@tanstack/react-router"
import { AvatarSelectorPage } from "@/pages/profile/avatar"

export const Route = createFileRoute("/_authenticated/profile/avatar")({
	component: AvatarSelectorPage,
})
